import { useAuth } from "./auth";

/**
 * True if the current user is a bedrijfsadmin (job_coach with elevated rights
 * within their company).
 */
export function useIsBedrijfsadmin() {
  const { user } = useAuth();
  return (
    !!user &&
    typeof user === "object" &&
    user.role === "job_coach" &&
    user.is_bedrijfsadmin === true
  );
}

export function useIsAdmin() {
  const { user } = useAuth();
  return !!user && typeof user === "object" && user.role === "admin";
}
